import React, { useEffect, useState } from "react";
import { FaCheck, FaPlus } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import { LuView } from "react-icons/lu";
import { HiOutlineRefresh } from "react-icons/hi";
import { FaSave } from "react-icons/fa";
import { IoPrint } from "react-icons/io5";
import { RiCloseLargeFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import { Col, Row } from "react-bootstrap";
import Select from 'react-select';

const Suppliermst = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        Supp_Nm: '', Supp_Address: '', Contact_Person: '', Contact_Person_Ph: '', Contact_Person_Email: '',
        Credit_Days: '', TIN: '', PAN: '', TDS_Section: '', Bank_Acc_No: '',
        Bank_Branch: '', IFSC: '', Gst_Reg: '', Gst_No: ''
    });
    const [showForm, setShowForm] = useState(false);
    const [items, setItems] = useState([]);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userName = user ? user.Emp_Name : 'Guest';
    const user_Id = user ? user.id : null;
    const user_Id_Emp = user ? user.Emp_id : null;
    useEffect(() => {
        fetchItems();
    }, [user_Id]);
    console.log('user_Id_Emp', user_Id_Emp)
    const fetchItems = async () => {
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/api/suppliers');
            if (!response.ok) {
                throw new Error('Failed to fetch items');
            }
            const data = await response.json();
            setItems(data);
        } catch (err) {
            console.error('Error fetching items:', err.message);
        }
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredItems, setFilteredItems] = useState([]);

    const [filteredItems1, setFilteredItems1] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showSearchh, setShowSearchh] = useState(false);
    const fetchItemss = async (searchTerm = '') => {
        try {
            const response = await fetch(`https://erpapi.emedha.in/pages/api/api/suppliers?searchTerm=${searchTerm}`);
            if (!response.ok) {
                throw new Error('Failed to fetch items');
            }
            const data = await response.json();
            const filtered = data.filter(supplier => supplier.Supp_cd === searchTerm);
            setFilteredItems1(filtered);
            setFilteredItems(data);
        } catch (err) {
            console.error('Error fetching items:', err.message);
        }
    };

    useEffect(() => {
        if (searchTerm) {
            fetchItemss(searchTerm);
        } else {
            setFilteredItems([]);
        }
    }, [searchTerm]);

    console.log('this is filteredItems', filteredItems)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);



    const handleSaveItems = async () => {
        console.log('this is formdata', formData)
        if (!formData.Supp_Nm || !formData.Bank_Acc_No || !formData.IFSC || !formData.Gst_No) {
            alert('Supp_Nm, Bank_Acc_No, and IFSC ,Gst_Reg are required!');
            return;
        }
        // const payload = {
        //     Supp_Nm: formData.Supp_Nm,
        //     Supp_Address: formData.Supp_Address,
        //     Contact_Person: formData.Contact_Person,
        //     Contact_Person_Ph: formData.Contact_Person_Ph,
        //     Contact_Person_Email: formData.Contact_Person_Email,
        //     Credit_Days: formData.Credit_Days,
        //     TIN: formData.TIN,
        //     PAN: formData.PAN,
        //     TDS_Section: formData.TDS_Section,
        //     Bank_Acc_No: formData.Bank_Acc_No,
        //     Bank_Branch: formData.Bank_Branch,
        //     IFSC: formData.IFSC,
        //     Gst_Reg: formData.Gst_Reg,
        //     Gst_No: formData.Gst_No,
        // };
        const payload = {
            Supp_Nm: formData.Supp_Nm,
            Supp_Address: formData.Supp_Address,
            Contact_Person: formData.Contact_Person,
            Contact_Person_Ph: formData.Contact_Person_Ph,
            Contact_Person_Email: formData.Contact_Person_Email,
            Credit_Days: formData.Credit_Days,
            TIN: formData.TIN,
            PAN: formData.PAN,
            TDS_Section: formData.TDS_Section,
            Bank_Acc_No: formData.Bank_Acc_No,
            Bank_Branch: formData.Bank_Branch,
            IFSC: formData.IFSC,
            Gst_Reg: formData.Gst_Reg,
            Gst_No: formData.Gst_No,
            items: rows.map(row => ({
                itemCd: row.itemCd,
                itemDesc: row.itemDesc
            }))
        };

        try {
            if (isEditing) {
                await axios.put(`https://erpapi.emedha.in/pages/api/api/suppliers/${editId}`, payload, {
                    headers: { 'Content-Type': 'application/json' }
                });
                // setItems(items.map(item => (item.Supp_cd === editId ? { ...formData, id: editId } : item)));
                setItems(items.map(item => item.Supp_cd === editId ? { ...item, ...formData, items: payload.items } : item));

                alert('Supplier updated successfully!');
            } else {
                const response = await axios.post('https://erpapi.emedha.in/pages/api/api/suppliers', payload, {
                    headers: { 'Content-Type': 'application/json' }
                });
                setItems([...items, { ...formData, id: response.data.id }]);
                alert('Supplier added successfully!');
                window.location.reload();
            }
            setShowForm(false);
        } catch (error) {
            console.error('Error saving supplier:', error);
        }
    };
    const handleEditItems = (item) => {
        setSearchTerm(item.Supp_cd);
        setFormData({
            Supp_Nm: item.Supp_Nm,
            Supp_Address: item.Supp_Address,
            Contact_Person: item.Contact_Person,
            Contact_Person_Ph: item.Contact_Person_Ph,
            Contact_Person_Email: item.Contact_Person_Email,
            Credit_Days: item.Credit_Days,
            TIN: item.TIN,
            PAN: item.PAN,
            TDS_Section: item.TDS_Section,
            Bank_Acc_No: item.Bank_Acc_No,
            Bank_Branch: item.Bank_Branch,
            IFSC: item.IFSC,
            Gst_Reg: item.Gst_Reg,
            Gst_No: item.Gst_No,
        });
        setEditId(item.Supp_cd);
        setIsEditing(true);
        setShowForm(true);
        setDropdownVisible1(false);
        setShowSearchh(false);
    };

    const handleSaveItem = async () => {
        console.log('this is formdata', formData);
        if (!formData.Supp_Nm || !formData.Bank_Acc_No || !formData.IFSC || !formData.Gst_No) {
            alert('Supp_Nm, Bank_Acc_No, IFSC and Gst_Reg are required!');
            return;
        }

        // Filter out empty rows
        const validRows = rows.filter(row => {
            const cd = row.itemCd ? String(row.itemCd).trim() : "";
            const desc = row.itemDesc ? String(row.itemDesc).trim() : "";
            return cd !== "" && desc !== "";
        });

        const payload = {
            Supp_Nm: formData.Supp_Nm,
            Supp_Address: formData.Supp_Address,
            Contact_Person: formData.Contact_Person,
            Contact_Person_Ph: formData.Contact_Person_Ph,
            Contact_Person_Email: formData.Contact_Person_Email,
            Credit_Days: formData.Credit_Days,
            TIN: formData.TIN,
            PAN: formData.PAN,
            TDS_Section: formData.TDS_Section,
            Bank_Acc_No: formData.Bank_Acc_No,
            Bank_Branch: formData.Bank_Branch,
            IFSC: formData.IFSC,
            Gst_Reg: formData.Gst_Reg,
            Gst_No: formData.Gst_No,
            // Only send valid items
            // items: validRows.map(row => ({
            //   itemCd: row.itemCd,
            //   itemDesc: row.itemDesc,
            //   id: row.id || null, // include id if editing existing items
            // })),
            items: isEditing
                ? filteredItems1.flatMap(supp =>
                    supp.items
                        .filter(itm => itm.itemCd && itm.itemDesc)
                        .map(itm => ({
                            id: itm.id || null,
                            itemCd: itm.itemCd,
                            itemDesc: itm.itemDesc,
                        }))
                )
                : validRows.map(row => ({
                    id: row.id || null,
                    itemCd: row.itemCd,
                    itemDesc: row.itemDesc,
                })),
        };
        console.log('this is payload', payload)
        try {
            if (isEditing) {
                await axios.put(`https://erpapi.emedha.in/pages/api/api/suppliers/${editId}`, payload, {
                    headers: { 'Content-Type': 'application/json' }
                });

                setItems(items.map(item =>
                    item.Supp_cd === editId ? { ...item, ...formData, items: payload.items } : item
                ));

                alert('Supplier updated successfully!');
            } else {
                const response = await axios.post('https://erpapi.emedha.in/pages/api/api/suppliers', payload, {
                    headers: { 'Content-Type': 'application/json' }
                });
                setItems([...items, { ...formData, id: response.data.id }]);
                alert('Supplier added successfully!');
                window.location.reload();
            }
            setShowForm(false);
        } catch (error) {
            console.error('Error saving supplier:', error);
        }
    };


    const handleEditItem = (item) => {
        setSearchTerm(item.Supp_cd);
        setFormData({
            Supp_Nm: item.Supp_Nm,
            Supp_Address: item.Supp_Address,
            Contact_Person: item.Contact_Person,
            Contact_Person_Ph: item.Contact_Person_Ph,
            Contact_Person_Email: item.Contact_Person_Email,
            Credit_Days: item.Credit_Days,
            TIN: item.TIN,
            PAN: item.PAN,
            TDS_Section: item.TDS_Section,
            Bank_Acc_No: item.Bank_Acc_No,
            Bank_Branch: item.Bank_Branch,
            IFSC: item.IFSC,
            Gst_Reg: item.Gst_Reg,
            Gst_No: item.Gst_No,
        });

        // Populate rows for edit mode
        setRows(item.items && item.items.length > 0
            ? item.items.map(itm => ({
                id: itm.id,         // important for update API
                itemCd: itm.itemCd,
                itemDesc: itm.itemDesc,
            }))
            : [{ itemCd: '', itemDesc: '' }] // at least one empty row if no items
        );

        setEditId(item.Supp_cd);
        setIsEditing(true);
        setShowForm(true);
        setDropdownVisible1(false);
        setShowSearchh(false);
    };




    const [showSearch, setShowSearch] = useState(false);
    const [dropdownVisible1, setDropdownVisible1] = useState(false);
    const handleBack = () => { navigate(-1); };
    const toggleForm = () => {
        setShowForm(prevState => !prevState);
        setFormData({ Supp_Nm: '', Supp_Address: '', Contact_Person: '', Contact_Person_Ph: '', Contact_Person_Email: '', Credit_Days: '', TIN: '', PAN: '', TDS_Section: '', Bank_Acc_No: '', Bank_Branch: '', IFSC: '', Gst_Reg: '', Gst_No: '' });
        setIsEditing(false);
        setEditId(null);
        setShowForm(true);
        setShowSearch(false);
        setShowSearchh(true);
    };

    const latestItem = items.reduce((max, item) => (item.Supp_cd > max.Supp_cd ? item : max), { Supp_cd: 0 });

    const handleRefresh = () => {
        setSelectedItem({ Supp_Nm: '', Supp_Address: '', Contact_Person: '', Contact_Person_Ph: '', Contact_Person_Email: '', Credit_Days: '', TIN: '', PAN: '', TDS_Section: '', Bank_Acc_No: '', Bank_Branch: '', IFSC: '', Gst_Reg: '', Gst_No: '' });
        setFormData({ Supp_Nm: '', Supp_Address: '', Contact_Person: '', Contact_Person_Ph: '', Contact_Person_Email: '', Credit_Days: '', TIN: '', PAN: '', TDS_Section: '', Bank_Acc_No: '', Bank_Branch: '', IFSC: '', Gst_Reg: '', Gst_No: '' });
    };
    const handleViewItem = (item) => {
        setSelectedItem(item);
        setShowForm(true);
        setFormMode('view');
        setShowSearchh(false);
        setShowSearch(true)
        // console.log('this is the Item', item)
        //setRows(item.items.length ? item.items : [{ itemCd: '', itemDesc: '' }]);
        //setRows(item.items?.length ? item.items : [{ itemCd: '', itemDesc: '' }]);

    };
    const handleInputBankChangee = (e) => {
        let value = e.target.value;
        if (/^\d{0,11}$/.test(value)) {
            setFormData({
                ...formData,
                Bank_Acc_No: value
            });
        }
    };
    const handleInputTinChangee = (e) => {
        let value = e.target.value;
        if (/^\d{0,11}$/.test(value)) {
            setFormData({
                ...formData,
                TIN: value
            });
        }
    };
    const handleInputCreditChangee = (e) => {
        let value = e.target.value;
        if (/^\d{0,3}$/.test(value)) {
            setFormData({
                ...formData,
                Credit_Days: value
            });
        }
    };
    const handleInputCPChangee = (e) => {
        let value = e.target.value;
        if (/^\d{0,11}$/.test(value)) {
            setFormData({
                ...formData,
                Contact_Person_Ph: value
            });
        }
    };
    const handleInputTdsChangge = (e) => {
        let value = e.target.value;
        if (/^[a-zA-Z0-9]{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                TDS_Section: value
            });
        }
    };
    const handleIfscPanInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 10) {
            setFormData({
                ...formData,
                PAN: value
            });
        }
    };
    const handleIfscInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 10) {
            setFormData({
                ...formData,
                IFSC: value
            });
        }
    };
    const handleBankBranchInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 30) {
            setFormData({
                ...formData,
                Bank_Branch: value
            });
        }
    };



    const [formMode, setFormMode] = useState('');

    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[1000].sub_ids[1002]?.permissions.add_permission || 0,
            edit: user.permissions[1000].sub_ids[1002]?.permissions.edit_permission || 0,
            view: user.permissions[1000].sub_ids[1002]?.permissions.view_permission || 0,
            save: user.permissions[1000].sub_ids[1002]?.permissions.save_permission || 0,
            approve: user.permissions[1000].sub_ids[1002]?.permissions.approve_permission || 0,
            print: user.permissions[1000].sub_ids[1002]?.permissions.print_permission || 0,
            close: user.permissions[1000].sub_ids[1002]?.permissions.exit_permission || 0,
            clear: user.permissions[1000].sub_ids[1002]?.permissions.refresh_permission || 0
        }
        : {};

    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };

    const handleApprove = (id) => {
        if (id) {
            axios
                .put(`https://erpapi.emedha.in/pages/api/api/supplier-mst/approve/${id}`)
                .then((response) => {
                    console.log('Item approved successfully:', response.data);
                    setItems((prevItems) =>
                        prevItems.map((item) =>
                            item.Supp_cd === id ? { ...item, isApproved: true } : item
                        )
                    );
                    alert('Item approved successfully');
                })
                .catch((error) => {
                    console.error('Error approving item:', error);
                    alert('Failed to approve item');
                });
        } else {
            alert("Item ID is invalid.");
        }
    };

    const handlePrint = () => {
        const printContent = document.getElementById("print-content");
        if (printContent) {
            const originalContent = document.body.innerHTML;
            document.body.innerHTML = printContent.innerHTML;
            window.print();
            document.body.innerHTML = originalContent;
        } else {
            alert("Print content not found!");
        }
    };
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);


    const verifyGstin = async () => {
        const gstin = formData.Gst_No; // Get GST number from form data

        if (!gstin) {
            setError("Please enter a GST number");
            return;
        }

        setIsLoading(true);

        try {
            // Send the request to your backend instead of directly to Cashfree
            const res = await axios.post('https://erpapi.emedha.in/pages/api/verify-gstin', { GSTIN: gstin });
            setResponse(res.data);
            setError(null);

            if (res.data.trade_name_of_business) {
                setFormData(prev => ({
                    ...prev,
                    Supp_Nm: res.data.trade_name_of_business  // ✅ Update Supplier Name
                }));
            }
        } catch (err) {
            setError(err.response ? err.response.data : "API request failed");
            setResponse(null);
        } finally {
            setIsLoading(false);
        }
    };


    const [itemss, setItemss] = useState([]);


    useEffect(() => {




        axios.get('https://erpapi.emedha.in/pages/api/api/itemsmasterform')
            .then((response) => {
                setItemss(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });

    }, []);

    const [rows, setRows] = useState([...Array(2)].map(() => ({ itemCd: '', itemDesc: '' })));


    const handleAddRow = () => {
        setRows((prevRows) => [
            ...prevRows,
            { itemCd: '', itemDesc: '' }
        ]);
    };


    const handleItemSelectss = (selectedOption, index) => {
        const selectedItem = itemss.find(item => item.itemCd === selectedOption.value);
        if (selectedItem) {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                itemCd: selectedItem.itemCd,
                itemDesc: selectedItem.itemDesc,
                itemUOM: selectedItem.itemUOM,
            };
            setRows(updatedRows);
        }
    };

    const handleItemSelectsss = (selectedOption, itemIndex, supplierIndex) => {
        const updatedSuppliers = [...filteredItems1];
        const supplier = updatedSuppliers[supplierIndex];
        supplier.items[itemIndex].itemCd = selectedOption.value;
        supplier.items[itemIndex].itemDesc = selectedOption.label; // auto update desc if you want
        setFilteredItems1(updatedSuppliers);
    };

    const handleItemSelects = (selectedOption, itemIndex, supplierIndex = null) => {
        if (formMode === 'edit') {
            // Update items for the supplier in edit mode
            const updatedSuppliers = [...filteredItems1];
            const selectedSupplier = { ...updatedSuppliers[supplierIndex] };

            const updatedItems = selectedSupplier.items.map((itm, idx) => {
                if (idx === itemIndex) {
                    return {
                        ...itm,
                        itemCd: selectedOption.value,
                        itemDesc: selectedOption.label,
                    };
                }
                return itm;
            });

            selectedSupplier.items = updatedItems;
            updatedSuppliers[supplierIndex] = selectedSupplier;

            setFilteredItems1(updatedSuppliers);
        } else {
            // Create mode
            const updatedRows = [...rows];
            updatedRows[itemIndex] = {
                ...updatedRows[itemIndex],
                itemCd: selectedOption.value,
                itemDesc: selectedOption.label,
            };
            setRows(updatedRows);
        }
    };





    const itemOptions = itemss.map((item) => ({
        value: item.itemCd,
        label: `${item.itemCd}-${item.itemDesc}`,
    }));



    // icons css 

    // ✅ SAME reusable styles (DON'T CHANGE)
    const iconBox = (enabled) => ({
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
        boxShadow: enabled ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
        cursor: enabled ? "pointer" : "not-allowed",
        opacity: enabled ? 1 : 0.5,
        transition: "all 0.3s ease",
    });

    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        borderRadius: "14px",
        background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    };

    const titleStyle = {
        color: "#1e3a8a",
        fontSize: "2rem",
        fontWeight: "700",
        letterSpacing: "1px",
    };

    const iconContainer = {
        display: "flex",
        gap: "14px",
        alignItems: "center",
    };

    return (
        <>
            <div style={{ backgroundColor: "#ffffff", padding: "1rem", margin: "0 auto", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", border: '1px solid black', borderRadius: '10px' }} >
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>
                        SUPPLIER MASTER
                    </h1>
                    <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                        }}>
                            <FaPlus size={30} onClick={() => {
                                if (userPermissions.add && userPermissions.add !== 0) {
                                    toggleForm();
                                    setShowSearch(false);
                                    setFormMode('create');
                                }
                            }} />
                        </div>

                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                        }}>
                            <MdEdit size={30} onClick={() => {
                                if (userPermissions.edit && userPermissions.edit !== 0) {
                                    setShowForm(true);
                                    setFormMode('edit');
                                    setShowSearch(true);
                                    setShowSearchh(false);
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                        }}>
                            <LuView size={30} onClick={userPermissions.view && userPermissions.view !== 0 ? handleViewItem : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                            opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                        }}>
                            <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                            opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                        }}>
                            <FaSave size={30} onClick={userPermissions.save && userPermissions.save !== 0 ? handleSaveItem : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                            opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                        }}>
                            <FaCheck size={30} onClick={userPermissions.approve && userPermissions.approve !== 0 ? () => handleApprove(selectedItem.Supp_cd) : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                            opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                        }}>
                            <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                            opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                        }}>
                            <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                        </div>
                    </div>
                </div> */}
                {/* // ✅ UI */}
                <div style={headerStyle}>

                    {/* Logo */}
                    <img src={A1} alt="supplier" style={{ width: "270px", borderRadius: "10px" }} />

                    {/* Title */}
                    <h1 style={titleStyle}>SUPPLIER MASTER</h1>

                    {/* Actions */}
                    <div style={iconContainer}>

                        {/* Add */}
                        <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
                            <FaPlus size={20} color="#2563eb"
                                onClick={() => {
                                    if (userPermissions.add && userPermissions.add !== 0) {
                                        toggleForm();
                                        setShowSearch(false);
                                        setFormMode('create');
                                    }
                                }}
                            />
                        </div>

                        {/* Edit */}
                        <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
                            <MdEdit size={20} color="#f59e0b"
                                onClick={() => {
                                    if (userPermissions.edit && userPermissions.edit !== 0) {
                                        setShowForm(true);
                                        setFormMode('edit');
                                        setShowSearch(true);
                                        setShowSearchh(false);
                                    }
                                }}
                            />
                        </div>

                        {/* View */}
                        <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
                            <LuView size={20} color="#10b981"
                                onClick={userPermissions.view && userPermissions.view !== 0 ? handleViewItem : null}
                            />
                        </div>

                        {/* Refresh */}
                        <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
                            <HiOutlineRefresh size={20} color="#6366f1"
                                onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
                            />
                        </div>

                        {/* Save */}
                        <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
                            <FaSave size={20} color="#22c55e"
                                onClick={userPermissions.save && userPermissions.save !== 0 ? handleSaveItem : null}
                            />
                        </div>

                        {/* Approve */}
                        <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
                            <FaCheck size={20} color="#16a34a"
                                onClick={userPermissions.approve && userPermissions.approve !== 0 ? () => handleApprove(selectedItem.Supp_cd) : null}
                            />
                        </div>

                        {/* Print */}
                        <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))}>
                            <IoPrint size={20} color="#0ea5e9"
                                onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
                            />
                        </div>

                        {/* Close */}
                        <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))}>
                            <RiCloseLargeFill size={20} color="#ef4444"
                                onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                            />
                        </div>

                    </div>
                </div>
                <p>Welcome To Supplier Master: {userName}</p>
                <hr />

                {!showForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}
                {showForm && (
                    <>
                        <div className="container">
                            {showSearch && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '32%', position: 'relative' }}>

                                    <input type="text" required placeholder="Search by Supp CD" value={searchTerm}
                                        onChange={(e) => { setSearchTerm(e.target.value); setDropdownVisible1(true); }}
                                        style={{ marginBottom: "1rem", padding: "0.25rem", border: "1px solid #dbc4a9", width: '100%' }} />
                                    {filteredItems.length > 0 && dropdownVisible1 && (
                                        <ul style={{ maxHeight: "150px", overflowY: "auto", border: "1px solid #dbc4a9", width: "100%", position: "absolute", backgroundColor: "#fff", zIndex: 1, marginTop: '5px', padding: 0, top: '100%' }}>
                                            {filteredItems.map((item) => (
                                                <li
                                                    key={item.id}
                                                    onClick={() => handleEditItem(item)}
                                                    style={{ padding: "0.5rem", cursor: "pointer", listStyleType: "none", borderBottom: "1px solid #dbc4a9" }}>
                                                    {item.Supp_cd}-{item.Supp_Nm}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}

                            {showSearchh && (
                                <div className="mb-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '32%', position: 'relative' }}>
                                    <input type="text" required placeholder="Item CD" value={latestItem ? latestItem.Supp_cd : ''} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" style={{ width: "100%", border: "1px solid #dbc4a9", padding: "0.25rem" }} />
                                </div>
                            )}

                            <div className="row">
                                {/* <div className="col-md-4 mb-2"><label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Supplier Name</label>
                                    <input type="text" className="form-control" name="Supp_Nm" value={formData.Supp_Nm} onChange={handleInputChange} maxLength="30" disabled={formMode === 'view'} />
                                </div> */}
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Supplier Name</label>
                                    <input
                                        type="text" required
                                        className="form-control"
                                        name="Supp_Nm"
                                        //value={response?.trade_name_of_business || formData.Supp_Nm}  // Map trade_name_of_business from response or fall back to formData.Supp_Nm
                                        value={formData.Supp_Nm}
                                        onChange={handleInputChange} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false"
                                        maxLength="30"
                                        disabled={formMode === 'view'}
                                    />
                                </div>



                                <div className="col-md-8 mb-2"><label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Supplier Address</label>
                                    <input type="text" required className="form-control" name="Supp_Address" value={formData.Supp_Address}
                                        onChange={handleInputChange} maxLength="200" disabled={formMode === 'view'} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" />
                                </div>
                            </div>
                            <div className="mt-3 row">
                                <div className="col-md-4 mb-2"><label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Contact Person</label>
                                    <input type="text" required className="form-control" name="Contact_Person" value={formData.Contact_Person} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputChange} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2"><label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Contact Person Phone</label>
                                    <input type="tel" required className="form-control" name="Contact_Person_Ph" value={formData.Contact_Person_Ph} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputCPChangee} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2"><label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Contact Person Email</label>
                                    <input type="email" required className="form-control" name="Contact_Person_Email" value={formData.Contact_Person_Email} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputChange} maxLength="50" disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Credit Days</label>
                                    <input type="text" required className="form-control" name="Credit_Days" value={formData.Credit_Days} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputCreditChangee} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>TIN</label>
                                    <input type="text" required className="form-control" name="TIN" value={formData.TIN} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputTinChangee} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>PAN</label>
                                    <input type="text" required className="form-control" name="PAN" value={formData.PAN} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleIfscPanInputChange} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>TDS Section</label>
                                    <input type="text" required className="form-control" name="TDS_Section" value={formData.TDS_Section} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputTdsChangge} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Bank Account Number</label>
                                    <input type="text" required className="form-control" name="Bank_Acc_No" value={formData.Bank_Acc_No} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleInputBankChangee} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>Bank Branch</label>
                                    <input type="text" required className="form-control" name="Bank_Branch" value={formData.Bank_Branch} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleBankBranchInputChange} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>IFSC</label>
                                    <input type="text" required className="form-control" name="IFSC" value={formData.IFSC} autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false" onChange={handleIfscInputChange} disabled={formMode === 'view'} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>GST Registration</label>
                                    <select className="form-control" name="Gst_Reg" value={formData.Gst_Reg} onChange={handleInputChange} disabled={formMode === 'view'}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </div>



                                <div className="col-md-4 mb-2">
                                    <div style={{ position: 'relative' }}>
                                        <label className="form-label" style={{ color: 'darkblue', fontWeight: 'bold' }}>GST No</label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            name="Gst_No"
                                            value={formData.Gst_No}
                                            onChange={handleInputChange} autoComplete="off"
                                            autoCorrect="off"
                                            autoCapitalize="off"
                                            spellCheck="false"
                                            maxLength="15" // Maximum GSTIN length
                                            disabled={false} // Adjust based on your form mode
                                        />

                                        {/* Display GST Status */}
                                        {response?.gst_in_status && (
                                            <p
                                                style={{
                                                    position: 'absolute',
                                                    top: '70%',
                                                    right: '20px',
                                                    transform: 'translateY(-50%)', // Center vertically within input
                                                    margin: 0,
                                                    color: response.gst_in_status === "Active" ? 'green' : 'black',
                                                    fontWeight: 'bold',
                                                    fontSize: '0.9em',
                                                }}
                                            >
                                                {response.gst_in_status === "Active" ? (
                                                    <span>✅ Active</span>
                                                ) : (
                                                    response.gst_in_status
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    <Row>
                                        <Col>
                                            <button onClick={verifyGstin} className="mt-2 btn btn-primary" disabled={isLoading}>
                                                {isLoading ? 'Verifying...' : 'Verify GST'}
                                            </button>
                                        </Col>
                                        <Col>
                                            {response && (
                                                <div className="mt-2">
                                                    {/* Display success/failure based on GST validation */}
                                                    {response.valid ? (
                                                        <p style={{ color: 'green' }}><strong>GST Verification Successful!</strong></p>
                                                    ) : (
                                                        <p style={{ color: 'red' }}><strong>GST Verification Failed</strong></p>
                                                    )}


                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    {error && (
                                        <div className="mt-3" style={{ color: 'red' }}>
                                            {/* Render error message */}
                                            <p>{typeof error === 'object' ? error.message || JSON.stringify(error) : error}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="p-1"></div>
                        </div>



                        {/******************* */}


                        <div className="container" style={{ overflowY: 'auto', maxHeight: '300px' }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', width: '10%' }}>Sl No.</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code 1</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                                    </tr>
                                </thead>
                                {formMode === 'create' && (

                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', textAlign: 'center' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid black', width: '30%' }}>
                                                    <Select
                                                        options={itemOptions}
                                                        //value={itemOptions.find(option => option.value === rows[index]?.itemCd)}
                                                        value={itemOptions.find(opt => opt.value === rows.itemCd) || null}
                                                        //value={itemOptions.find(option => String(option.value) === String(row.itemCd)) || null}
                                                        //value={itemOptions.find(option => option.value === row.itemCd)}
                                                        onChange={(selectedOption) => handleItemSelects(selectedOption, index)}
                                                        //onChange={(selectedOption) => handleItemSelects(selectedOption, itemIndex, supplierIndex)}
                                                        onBlur={() => { row.showSelect = false; }}
                                                        isDisabled={formMode === 'view'}
                                                        placeholder="Select Item"
                                                        styles={{
                                                            container: (provided) => ({ ...provided, width: '100%', }),
                                                            control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px', }),
                                                            menu: (provided) => ({ ...provided, width: '325px', overflowY: 'auto', }),
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ border: '1px solid black' }}>

                                                    <input type="text" style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent', }}
                                                        value={row.itemDesc || ''}
                                                        onChange={(e) => handleInputChange(e, index)} autoComplete="off"
                                                        autoCorrect="off"
                                                        autoCapitalize="off"
                                                        spellCheck="false"
                                                        readOnly
                                                        disabled={formMode === 'view'} />

                                                </td>
                                            </tr>
                                        ))}

                                        <tr>
                                            <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}><button onClick={handleAddRow} style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}><FaPlus /> Add Row</button></td>
                                        </tr>
                                    </tbody>
                                )}
                                {/********** */}
                                {formMode === 'view' && (
                                    <tbody>
                                        {filteredItems1.map((supplier, supplierIndex) => (
                                            // Check if supplier has items and render them
                                            supplier.items.length > 0 ? (
                                                supplier.items.map((item, itemIndex) => (
                                                    <tr key={`${supplierIndex}-${itemIndex}`}>
                                                        <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                            {supplierIndex * 10 + itemIndex + 1} {/* Unique Sl No */}
                                                        </td>
                                                        {/* <td style={{ border: '1px solid black', width: '30%' }}>
                                    <Select
                                        options={itemOptions}
                                        value={itemOptions.find(option => option.value === item.itemCd)}
                                        onChange={(selectedOption) => handleItemSelects(selectedOption, itemIndex, supplierIndex)}
                                        onBlur={() => { item.showSelect = false; }}
                                        isDisabled={formMode === 'view'}
                                        placeholder="Select Item"
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '100%' }),
                                            control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px' }),
                                            menu: (provided) => ({ ...provided, width: '325px', overflowY: 'auto' }),
                                        }}
                                    />
                                </td> */}
                                                        <td style={{ border: '1px solid black', width: '30%' }}>
                                                            <input
                                                                type="text"
                                                                style={{ border: 'black', outline: 'black', width: '100%', height: '40px', backgroundColor: 'transparent' }}
                                                                value={item.itemCd || ''}
                                                                onChange={(e) => handleInputChange(e, itemIndex, supplierIndex)} autoComplete="off"
                                                                autoCorrect="off"
                                                                autoCapitalize="off"
                                                                spellCheck="false"
                                                                readOnly
                                                                disabled={formMode === 'view'}
                                                            />
                                                        </td>
                                                        <td style={{ border: '1px solid black' }}>
                                                            <input
                                                                type="text"
                                                                style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                                                value={item.itemDesc || ''} autoComplete="off"
                                                                autoCorrect="off"
                                                                autoCapitalize="off"
                                                                spellCheck="false"
                                                                onChange={(e) => handleInputChange(e, itemIndex, supplierIndex)}
                                                                readOnly
                                                                disabled={formMode === 'view'}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr key={supplier.Supp_cd}>
                                                    <td colSpan="3" style={{ textAlign: 'center', padding: '10px' }}>
                                                        No items available for {supplier.Supp_Nm}.
                                                    </td>
                                                </tr>
                                            )
                                        ))}
                                        <tr>
                                            {/* <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}>
                        <button
                            onClick={handleAddRow}
                            style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}
                        >
                            <FaPlus /> Add Row
                        </button>
                    </td> */}
                                        </tr>
                                    </tbody>
                                )}

                                {formMode === 'edit' && (
                                    <tbody>
                                        {filteredItems1.map((supplier, supplierIndex) =>
                                            supplier.items.length > 0 ? (
                                                supplier.items.map((item, itemIndex) => (
                                                    <tr key={`${supplierIndex}-${itemIndex}`}>
                                                        <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                            {supplierIndex * 10 + itemIndex + 1}
                                                        </td>

                                                        <td style={{ border: '1px solid black', width: '30%' }}>
                                                            <Select
                                                                options={itemOptions}
                                                                value={itemOptions.find(opt => opt.value === item.itemCd) || null}
                                                                onChange={(selectedOption) => {
                                                                    handleItemSelects(selectedOption, itemIndex, supplierIndex)
                                                                }}
                                                                placeholder="Select Item"
                                                                styles={{
                                                                    container: (provided) => ({ ...provided, width: '100%' }),
                                                                    control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px' }),
                                                                    menu: (provided) => ({ ...provided, width: '325px', overflowY: 'auto' }),
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ border: '1px solid black' }}>
                                                            <input
                                                                type="text"
                                                                style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                                                value={item.itemDesc || ''}
                                                                readOnly autoComplete="off"
                                                                autoCorrect="off"
                                                                autoCapitalize="off"
                                                                spellCheck="false"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr key={supplier.Supp_cd}>
                                                    <td colSpan="3" style={{ textAlign: 'center', padding: '10px' }}>
                                                        No items available for {supplier.Supp_Nm}.
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                )}

                            </table>
                        </div>

                    </>
                )}

            </div>
        </>
    );
};

export default Suppliermst;







{/* {formMode === 'view' && (
    <div className="container" style={{ overflowY: 'auto', maxHeight: '300px' }}>
        <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
            <thead>
                <tr>
                    <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', width: '10%' }}>Sl No.</th>
                    <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                    <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                </tr>
            </thead>
            <tbody>
                {filteredItems1.map((supplier, supplierIndex) => (
                    // Check if supplier has items and render them
                    supplier.items.length > 0 ? (
                        supplier.items.map((item, itemIndex) => (
                            <tr key={`${supplierIndex}-${itemIndex}`}>
                                <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                    {supplierIndex * 10 + itemIndex + 1} {/* Unique Sl No *
                                </td>
                                {/* <td style={{ border: '1px solid black', width: '30%' }}>
                                    <Select
                                        options={itemOptions}
                                        value={itemOptions.find(option => option.value === item.itemCd)}
                                        onChange={(selectedOption) => handleItemSelects(selectedOption, itemIndex, supplierIndex)}
                                        onBlur={() => { item.showSelect = false; }}
                                        isDisabled={formMode === 'view'}
                                        placeholder="Select Item"
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '100%' }),
                                            control: (provided) => ({ ...provided, border: '2px solid #D1D5DB', backgroundColor: 'transparent', height: '40px' }),
                                            menu: (provided) => ({ ...provided, width: '325px', overflowY: 'auto' }),
                                        }}
                                    />
                                </td> *
                                <td style={{ border: '1px solid black', width: '30%'  }}>
                                    <input
                                        type="text"
                                        style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                        value={item.itemCd || ''}
                                        onChange={(e) => handleInputChange(e, itemIndex, supplierIndex)}
                                        readOnly
                                        disabled={formMode === 'view'}
                                    />
                                </td>
                                <td style={{ border: '1px solid black' }}>
                                    <input
                                        type="text"
                                        style={{ border: 'black', outline: 'black', width: '100%', backgroundColor: 'transparent' }}
                                        value={item.itemDesc || ''}
                                        onChange={(e) => handleInputChange(e, itemIndex, supplierIndex)}
                                        readOnly
                                        disabled={formMode === 'view'}
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr key={supplier.Supp_cd}>
                            <td colSpan="3" style={{ textAlign: 'center', padding: '10px' }}>
                                No items available for {supplier.Supp_Nm}.
                            </td>
                        </tr>
                    )
                ))}
                <tr>
                    <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}>
                        <button
                            onClick={handleAddRow}
                            style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}
                        >
                            <FaPlus /> Add Row
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
)} */}

